module.exports = __webpack_public_path__ + "static/media/ascarlyshcarlyshr1e032.e062bf2c.jpg";